import { render, staticRenderFns } from "./ques21.vue?vue&type=template&id=21d5eb85&scoped=true"
import script from "./ques21.vue?vue&type=script&lang=js"
export * from "./ques21.vue?vue&type=script&lang=js"
import style0 from "./ques21.vue?vue&type=style&index=0&id=21d5eb85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5eb85",
  null
  
)

export default component.exports